export interface GoldType {
  id: string;
  name: string;
  code: string;
  unit: string;
  buy: number;
  sell: number;
  change: number;
  changePercent: number;
  updated: string;
}

export const goldTypes: GoldType[] = [
  { id: 'sjc-1l', name: 'Vàng miếng SJC 1L', code: 'SJC 1L', unit: 'lượng', buy: 141000000, sell: 144000000, change: 700000, changePercent: 0.50, updated: '14:30 15/08/2026' },
  { id: 'sjc-5l', name: 'Vàng miếng SJC 5L', code: 'SJC 5L', unit: 'lượng', buy: 141000000, sell: 144000000, change: 700000, changePercent: 0.50, updated: '14:30 15/08/2026' },
  { id: 'nhan-sjc', name: 'Nhẫn tròn SJC 9999', code: 'SJC 9999', unit: 'lượng', buy: 140500000, sell: 143500000, change: 650000, changePercent: 0.46, updated: '14:29 15/08/2026' },
  { id: 'nhan-pnj', name: 'Nhẫn tròn PNJ 9999', code: 'PNJ 9999', unit: 'lượng', buy: 140300000, sell: 143900000, change: 600000, changePercent: 0.42, updated: '14:29 15/08/2026' },
  { id: 'doji-9999', name: 'Vàng DOJI 9999', code: 'DOJI', unit: 'lượng', buy: 141000000, sell: 144000000, change: 700000, changePercent: 0.50, updated: '14:28 15/08/2026' },
  { id: 'vang-24k', name: 'Vàng 24K (99.99%)', code: '24K', unit: 'lượng', buy: 139800000, sell: 142800000, change: 500000, changePercent: 0.36, updated: '14:28 15/08/2026' },
  { id: 'vang-18k', name: 'Vàng 18K (75%)', code: '18K', unit: 'lượng', buy: 105500000, sell: 108000000, change: 400000, changePercent: 0.38, updated: '14:27 15/08/2026' },
  { id: 'vang-14k', name: 'Vàng 14K (58.3%)', code: '14K', unit: 'lượng', buy: 82000000, sell: 84500000, change: 300000, changePercent: 0.37, updated: '14:27 15/08/2026' },
];

export const priceHistory30d = [
  { date: '17/07', price: 133000000 },
  { date: '18/07', price: 133500000 },
  { date: '19/07', price: 132800000 },
  { date: '20/07', price: 134000000 },
  { date: '21/07', price: 134800000 },
  { date: '22/07', price: 134200000 },
  { date: '23/07', price: 135000000 },
  { date: '24/07', price: 135800000 },
  { date: '25/07', price: 135300000 },
  { date: '26/07', price: 136200000 },
  { date: '27/07', price: 135800000 },
  { date: '28/07', price: 136500000 },
  { date: '29/07', price: 137000000 },
  { date: '30/07', price: 136600000 },
  { date: '31/07', price: 137500000 },
  { date: '01/08', price: 138000000 },
  { date: '02/08', price: 137600000 },
  { date: '03/08', price: 138400000 },
  { date: '04/08', price: 138000000 },
  { date: '05/08', price: 138800000 },
  { date: '06/08', price: 138300000 },
  { date: '07/08', price: 139200000 },
  { date: '08/08', price: 139000000 },
  { date: '09/08', price: 139600000 },
  { date: '10/08', price: 139300000 },
  { date: '11/08', price: 140000000 },
  { date: '12/08', price: 139700000 },
  { date: '13/08', price: 140500000 },
  { date: '14/08', price: 140800000 },
  { date: '15/08', price: 141000000 },
];

export const priceHistory24h = [
  { time: '00:00', price: 140300000 },
  { time: '01:00', price: 140300000 },
  { time: '02:00', price: 140350000 },
  { time: '03:00', price: 140350000 },
  { time: '04:00', price: 140400000 },
  { time: '05:00', price: 140450000 },
  { time: '06:00', price: 140500000 },
  { time: '07:00', price: 140550000 },
  { time: '08:00', price: 140600000 },
  { time: '09:00', price: 140700000 },
  { time: '10:00', price: 140750000 },
  { time: '11:00', price: 140800000 },
  { time: '12:00', price: 140850000 },
  { time: '13:00', price: 140800000 },
  { time: '14:00', price: 140900000 },
  { time: '15:00', price: 141000000 },
];